import { RequestCreditLimitIncreaseCTA } from "./ctas";
export var RequestCreditLimitIncreaseIA = function RequestCreditLimitIncreaseIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return REQUEST_CREDIT_LIMIT_INCREASE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [SUBMIT_REQUEST_USING_BUTTON(strictLocalize), PLEASE_NOTE(strictLocalize), TIMELINE(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(_context) {
        return RequestCreditLimitIncreaseCTA(strictLocalize).label;
      },
      linkBuilder: function linkBuilder(_context) {
        var _RequestCreditLimitIn, _RequestCreditLimitIn2;
        return (_RequestCreditLimitIn = (_RequestCreditLimitIn2 = RequestCreditLimitIncreaseCTA(strictLocalize)).getLink) === null || _RequestCreditLimitIn === void 0 ? void 0 : _RequestCreditLimitIn.call(_RequestCreditLimitIn2);
      }
    }
  };
};
var REQUEST_CREDIT_LIMIT_INCREASE = function REQUEST_CREDIT_LIMIT_INCREASE(strictLocalize) {
  return strictLocalize({
    id: "ugdDrA",
    defaultMessage: [{
      "type": 0,
      "value": "Demander une augmentation du montant disponible dans les conditions de paiement"
    }]
  });
};
var SUBMIT_REQUEST_USING_BUTTON = function SUBMIT_REQUEST_USING_BUTTON(strictLocalize) {
  return strictLocalize({
    id: "LkoWL2",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous souhaitez demander une augmentation de votre limite, cliquez sur le bouton ci-dessous."
    }]
  });
};
var PLEASE_NOTE = function PLEASE_NOTE(strictLocalize) {
  return strictLocalize({
    id: "lRQgRb",
    defaultMessage: [{
      "type": 0,
      "value": "Attention : si vous avez déjà demandé une augmentation au cours des 3 derniers mois, il est possible que ce bouton ne soit pas visible sur votre compte et que vous deviez demander une intervention manuelle de notre service des paiements."
    }]
  });
};
var TIMELINE = function TIMELINE(strictLocalize) {
  return strictLocalize({
    id: "Jl6C3w",
    defaultMessage: [{
      "type": 0,
      "value": "Nous examinerons votre demande et vous répondrons généralement dans un délai de 3 à 7 jours ouvrés."
    }]
  });
};